// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_jtV","cls2":"Configuration-cls2_jKa Configuration-cls1_jtV"};